import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class StorageDataService {
  // Local storage functions
  getLocalStorageItem(name: string): string {
    try {
      return this.decode(localStorage.getItem(name));
    } catch {
      return null;
    }
  }

  setLocalStorageItem(name: string, value: any): void {
    try {
      localStorage.setItem(name, this.encode(value));
    } catch {}
  }

  removeLocalStorageItem(name: string): void {
    try {
      localStorage.removeItem(name);
    } catch {}
  }

  removeAllLocalStorageData(): void {
    try {
      localStorage.clear();
    } catch {}
  }

  getSessionStorageItem(name: string): string {
    try {
      return this.decode(sessionStorage.getItem(name));
    } catch {
      return null;
    }
  }

  setSessionStorageItem(name: string, value: any): void {
    try {
      sessionStorage.setItem(name, this.encode(value));
    } catch {}
  }

  removeSessonStorageItem(name: string): void {
    try {
      sessionStorage.removeItem(name);
    } catch {}
  }

  removeAllSessionStorageData(): void {
    try {
      sessionStorage.clear();
    } catch {}
  }

  /**
   * Get an item from either local or session storage
   * @param name
   */
  getStorageItem(name: string): string {
    return this.getLocalStorageItem(name) || this.getSessionStorageItem(name);
  }

  /**
   * Encode and protect value
   * Prevent user from changing values in local or session storage
   * @param value
   */
  private encode(value: string): string {
    if (value) {
      return window.btoa(value);
    }
    return value;
  }

  /**
   * Decode protected value
   * @param value
   */
  private decode(value: string): string {
    if (value) {
      return window.atob(value);
    }
    return value;
  }
}
